import React from 'react';

interface BeableLogoWithNameProps {
  height?: string | number;
}

const BeableLogoWithName: React.FunctionComponent<BeableLogoWithNameProps> = ({ height = '50px' }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height={ height }
      version='1.1'
      viewBox='0 0 210 110'
    >
      <path
        fill='#e8035c'
        fillOpacity='1'
        fillRule='nonzero'
        stroke='none'
        d='M0 0c0 28.822 17.456 49.38 44.564 54.122-3.955.686-8.127 1.044-12.501 1.044-14.66 0-24.633-5.748-31.487-11.201L.292 72.268l-26.025-20.914V.663c0-32.997 22.878-55.166 56.927-55.166 3.829 0 7.509.295 11.039.84C16.46-48.175 0-27.985 0 0'
        transform='matrix(.35278 0 0 -.35278 55.265 37.735)'
      ></path>
      <path
        fill='#e8035c'
        fillOpacity='1'
        fillRule='nonzero'
        stroke='none'
        d='M0 0c-2.435-7.178-7.332-12.521-14.083-15.42 4.069-2.031 8.81-3.139 13.991-3.139 10.406 0 16.675 3.006 21.068 8.619h6.557A57.17 57.17 0 0130.165.007z'
        transform='matrix(.35278 0 0 -.35278 75.38 41.433)'
      ></path>
      <path
        fill='#e8035c'
        fillOpacity='1'
        fillRule='nonzero'
        stroke='none'
        d='M0 0h26.327C22.2 12.768 10.396 17.63-.217 17.63c-4.573 0-8.809-.865-12.546-2.46C-6.63 12.096-2.218 6.852 0 0'
        transform='matrix(.35278 0 0 -.35278 75.424 33.71)'
      ></path>
      <path
        fill='#17b2f0'
        fillOpacity='1'
        fillRule='nonzero'
        stroke='none'
        d='M0 0c0-3.87-.327-7.584-.937-11.138l25.026.006c.538 3.352.83 6.84.83 10.469 0 32.997-22.063 55.166-56.113 55.166-4.307 0-8.435-.357-12.362-1.044C-16.718 48.807 0 28.856 0 0'
        transform='matrix(.35278 0 0 -.35278 86.352 37.501)'
      ></path>
      <path
        fill='#1c1954'
        fillOpacity='1'
        fillRule='nonzero'
        stroke='none'
        d='M0 0c-5.181 0-9.922 1.108-13.991 3.14C-17.717 1.541-21.984.661-26.732.661c-13.819 0-28.582 7.63-28.582 29.042 0 .574.087 5.986.284 7.055 2.306 12.534 14.47 21.986 28.298 21.986 5.367 0 10.143-1.095 14.187-3.121 3.736 1.595 7.973 2.46 12.545 2.46 10.613 0 22.417-4.862 26.544-17.63H.217c1.051-3.245 1.633-6.833 1.633-10.75 0-4.075-.623-7.798-1.758-11.144l30.165.007c.61 3.554.937 7.268.937 11.137 0 28.856-16.718 48.808-43.556 53.459-27.108-4.741-44.564-25.3-44.564-54.122 0-27.984 16.46-48.174 42.233-53.663C5.875-21.449 21.075-9.308 27.625 8.619h-6.557C16.675 3.006 10.406 0 0 0'
        transform='matrix(.35278 0 0 -.35278 75.347 47.98)'
      ></path>
      <path
        fill='#333'
        fillOpacity='1'
        fillRule='nonzero'
        stroke='none'
        d='M0 0c-27.826 0-46.523-18.118-46.523-45.084 0-27.058 17.983-44.542 45.813-44.542 11.98 0 20.131 4.697 25.732 9.154l.232-7.617h21.268v43.005C46.522-18.118 27.826 0 0 0m23.942-50.849C22.058-61.093 12.117-68.817.817-68.817c-14.191 0-23.359 9.316-23.359 23.733 0 14.418 9.168 23.734 23.359 23.734 11.293 0 23.358-6.235 23.358-23.734 0-.469-.071-4.892-.233-5.765'
        transform='matrix(.35278 0 0 -.35278 95.865 63.117)'
      ></path>
      <path
        fill='#333'
        fillOpacity='1'
        fillRule='nonzero'
        stroke='none'
        d='M0 0c27.826 0 46.523 18.118 46.523 45.084 0 27.058-17.983 44.542-45.813 44.542-11.98 0-20.13-4.697-25.732-9.154l-.233 33.765-21.267-15.373v-53.78C-46.522 18.118-27.826 0 0 0m-23.942 50.849c1.884 10.244 11.825 17.968 23.125 17.968 14.191 0 23.359-9.316 23.359-23.733 0-14.418-9.168-23.734-23.359-23.734-11.293 0-23.359 6.235-23.359 23.734 0 .469.072 4.892.234 5.765'
        transform='matrix(.35278 0 0 -.35278 25.997 94.735)'
      ></path>
      <path
        fill='#333'
        fillOpacity='1'
        fillRule='nonzero'
        stroke='none'
        d='M0 0c27.826 0 46.522 18.118 46.522 45.084 0 27.058-17.982 44.542-45.812 44.542-11.98 0-20.131-4.697-25.732-9.154l-.232 33.765-21.268-15.373v-53.78C-46.522 18.118-27.826 0 0 0m-23.943 50.849c1.885 10.244 11.826 17.968 23.126 17.968 14.191 0 23.359-9.316 23.359-23.733 0-14.418-9.168-23.734-23.359-23.734-11.293 0-23.358 6.235-23.358 23.734 0 .469.071 4.892.232 5.765'
        transform='matrix(.35278 0 0 -.35278 131.172 94.735)'
      ></path>
      <path
        fill='#333'
        fillOpacity='1'
        fillRule='nonzero'
        stroke='none'
        d='M0 0c0 26.966-18.03 45.084-45.857 45.084-27.827 0-46.522-18.118-46.522-45.084 0-26.965 18.695-45.083 46.522-45.083 21.589 0 37.676 10.911 43.806 28.394H-28.64c-3.59-4.587-8.713-7.044-17.217-7.044-10.735 0-19.215 5.743-22.066 15.162l67.245.015A53.98 53.98 0 010 0m-45.857 23.734c8.673 0 18.32-3.973 21.692-14.407h-43.526c3.029 8.973 11.387 14.407 21.834 14.407'
        transform='matrix(.35278 0 0 -.35278 77.203 79.022)'
      ></path>
      <path
        fill='#333'
        fillOpacity='1'
        fillRule='nonzero'
        stroke='none'
        d='M0 0c0 26.966-18.03 45.084-45.857 45.084-27.826 0-46.522-18.118-46.522-45.084 0-26.965 18.696-45.083 46.522-45.083 21.59 0 37.676 10.911 43.806 28.394H-28.64c-3.59-4.587-8.713-7.044-17.217-7.044-10.735 0-19.214 5.743-22.065 15.162l67.244.015C-.238-5.817 0-2.965 0 0m-45.857 23.734c8.673 0 18.32-3.973 21.693-14.407h-43.527c3.03 8.973 11.387 14.407 21.834 14.407'
        transform='matrix(.35278 0 0 -.35278 197.545 79.022)'
      ></path>
      <path
        fill='#333'
        fillOpacity='1'
        fillRule='nonzero'
        stroke='none'
        d='M0 0v85.719l-24.578-13.212V-1.789c0-16.401 11.294-25.191 26.227-25.191 8.318 0 15.449 1.305 15.449 1.305V-4.8s-4.218-.412-5.637-.504C5.516-5.692 0-5.972 0 0'
        transform='matrix(.35278 0 0 -.35278 158.667 84.675)'
      ></path>
    </svg>
  );
};

export default BeableLogoWithName;
